var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Illustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366.409,
    height: 234.494,
    viewBox: "0 0 366.409 234.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#ccc;}.b,.q{opacity:0.29;}.c{fill:#fff;}.d{fill:#16679a;}.e,.v{fill:#0899ba;}.f{fill:#ff6565;}.g,.o{fill:#f9ca24;}.h{fill:#337ead;}.i{fill:#0f5c93;}.j{fill:#f98d3d;}.k{fill:#ed701b;}.l{fill:none;}.m{fill:#f6e58d;}.n{fill:#efaa3a;}.o{opacity:0.66;}.p{fill:#49b4d6;}.q{fill:#e0ad00;}.r{fill:#f77e2d;}.s{fill:#79c9e8;}.t{opacity:0.55;fill:url(#a);}.u{fill:#e7b200;opacity:0.68;}.v{opacity:0.19;}.w{fill:#263238;}.x{fill:#c09401;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.718,
    x2: 0.5,
    y2: 0.108,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.369
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-492.592 -248.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M355.451,361.429a10.8,10.8,0,0,0,10.816-10.655c.45-29.386,2.816-72.736-52.537-84.731-44.809-9.671-18.231-89.278-138.855-84.087-86.6,3.69-63.625,76.672-130.914,82.755-44.809,4-45.191,60.664-43.468,86.623a10.8,10.8,0,0,0,10.782,10.1Z",
    transform: "translate(492.592 121.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.794,266.069c-44.809-9.7-18.231-89.3-138.855-84.112-20.6.848-34.985,5.675-45.869,12.564,3.665-.484,7.559-.848,11.707-.993,120.624-5.149,94.071,74.45,138.863,84.154,54.76,11.877,53.021,54.42,52.546,83.79h23.329a10.8,10.8,0,0,0,10.816-10.7C389.781,321.414,392.148,278.064,336.794,266.069Z",
    transform: "translate(469.527 121.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M277.319,175.031,135.647,158.5a11.028,11.028,0,0,0-12.233,9.679L112.887,258.7a11.028,11.028,0,0,0,9.679,12.233l141.671,16.534a11.028,11.028,0,0,0,12.233-9.679l10.57-90.568a11.028,11.028,0,0,0-9.722-12.191Z",
    transform: "translate(475.482 125.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M287.662,196.188l1.043-8.967a11.028,11.028,0,0,0-9.679-12.19L137.355,158.5a11.028,11.028,0,0,0-12.233,9.679l-1.052,8.967Z",
    transform: "translate(473.773 125.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M150.961,238.9l17.951-31.634a5.786,5.786,0,0,1,5.718-2.893h0a5.786,5.786,0,0,1,5.09,6.43l-3.733,32h.161a4.013,4.013,0,0,1,3.538,4.513h0a4.03,4.03,0,0,1-4.462,3.529h-.161l-.679,5.828a4.335,4.335,0,0,1-4.81,3.809h0a4.335,4.335,0,0,1-3.809-4.81l.679-5.828-12.92-1.51a4.021,4.021,0,0,1-3.538-4.462l.348-2.935a5.039,5.039,0,0,1,.628-2.036Zm16.458,2.367,2.316-19.842a.127.127,0,0,0-.238-.076l-10.6,18.714a.534.534,0,0,0,.4.789l7.542.848A.534.534,0,0,0,167.418,241.267Z",
    transform: "translate(469.848 118.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M244.349,249.82,262.3,218.186a5.811,5.811,0,0,1,5.718-2.893h0a5.8,5.8,0,0,1,5.09,6.43l-3.758,31.982h.161a4.013,4.013,0,0,1,3.521,4.454h0a4.013,4.013,0,0,1-4.454,3.529h-.161l-.679,5.828a4.344,4.344,0,0,1-4.819,3.8h0a4.327,4.327,0,0,1-3.8-4.81l.679-5.828-12.9-1.527a4.021,4.021,0,0,1-3.529-4.462l.339-2.935A5.328,5.328,0,0,1,244.349,249.82Zm16.466,2.367,2.316-19.842a.127.127,0,0,0-.238-.076l-10.6,18.714a.526.526,0,0,0,.4.789l7.533.848a.534.534,0,0,0,.594-.45Z",
    transform: "translate(455.686 116.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M201.914,220.883c1.043-8.933,6.346-13.5,14.965-12.487s12.725,6.659,11.69,15.6l-3.393,29.055c-1.052,8.941-6.354,13.5-14.973,12.5s-12.725-6.668-11.69-15.609Zm5.319,30.642c-.467,4,1.111,5.709,3.911,6.04s4.725-.984,5.192-4.98l3.521-30.124c.467-4-1.111-5.718-3.911-6.04s-4.725.984-5.192,4.971Z",
    transform: "translate(462.508 117.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M142.752,172.619a2.969,2.969,0,1,1-2.6-3.283A2.969,2.969,0,0,1,142.752,172.619Z",
    transform: "translate(471.838 123.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M159.5,174.578a2.961,2.961,0,1,1-.615-2.184A2.961,2.961,0,0,1,159.5,174.578Z",
    transform: "translate(469.297 123.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M176.855,176.6a2.961,2.961,0,1,1-2.6-3.283,2.961,2.961,0,0,1,2.6,3.283Z",
    transform: "translate(466.664 122.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M110.351,298.452a76.538,76.538,0,0,0-1.595,17.145c.288,7.762-.636,58.8-.636,58.8h6.235s8.874-39.965,9.2-43.121,4.819-34.714,4.819-34.714Z",
    transform: "translate(476.193 104.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M115.64,296.05a134.745,134.745,0,0,0,3.868,18.663c2.435,7.762,14.422,59.621,14.422,59.621h6.235s-1.145-39.965-1.578-43.121S135,296.491,135,296.491Z",
    transform: "translate(475.053 104.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M137.81,388.31v4.352h11.877a.679.679,0,0,0,.373-1.247,18.572,18.572,0,0,0-7.1-3.1Z",
    transform: "translate(471.689 90.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M108.49,388.31v4.352h11.877a.679.679,0,0,0,.382-1.247,18.926,18.926,0,0,0-7.1-3.1Z",
    transform: "translate(476.137 90.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131,235.026s4.08-6.2-.6-6.787c-3.6-.467-5.09.6-5.09.6s-4.14-.45-6.4,1.51c-1.552,1.349-7.262,11.792,1.96,15.567s7.262-5.938,7.262-5.938Z",
    transform: "translate(475.039 114.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M130.378,228.219c-3.6-.467-5.09.6-5.09.6s-4.14-.45-6.4,1.51c-1.552,1.349-7.262,11.792,1.96,15.567,4.335,1.781,6.2.585,6.956-1.188-8.746,2.469-9.7-8.076-8.254-11.079s4.98-1.637,4.98-1.637c1.383-3.47,5.862-3.088,7.711-2.825a2.545,2.545,0,0,0-1.858-.95Z",
    transform: "translate(475.041 114.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M126.216,239.285s-1.2-1.213-2.112,0-.305,3.928,1.2,4.08c0,0-.45,3.928-3.478,3.775v3.181h7.109v-2.4s4.386-1.807,4.242-5.438a19.953,19.953,0,0,0-1.213-6.193A9.9,9.9,0,0,1,126.216,239.285Z",
    transform: "translate(474.113 113.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M127.774,250.841c.7.3.585.738.611,1.408h1.026v-2.4A5.752,5.752,0,0,1,125.17,249a11.223,11.223,0,0,0,2.6,1.841Z",
    transform: "translate(473.607 111.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M129.253,232.861s-3.682-1.468-4.114-.365c-.28.721.433,1.34,1.417,1.968l-.848.136a.229.229,0,0,0-.11.407,4.9,4.9,0,0,0,2.3.373Z",
    transform: "translate(473.621 113.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M104.14,278.773l4.929,15.906-.085-.806.085.806,1.671-23.159Z",
    transform: "translate(476.797 108.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M150.664,242.2c-7.016-5.2-26.2-9.332-26.2-9.332l-1.578,2.884s17.408,6.787,16.254,7.754c-.67.594-9.179,4.488-12.063,5.8a4.615,4.615,0,0,1-1.977.407l-8.814-.051a13.921,13.921,0,0,0-11.368,4.988c-4.471,5.149-12.072,17.068-12.072,17.068l12.81,18.833,1.417,2.078v.153l1.264.127c4.114.382,17.306,1.425,24.288-.059l.2-.042-.331-30.9A119.8,119.8,0,0,0,150.876,244.1a1.3,1.3,0,0,0-.212-1.9Zm-43.01,42.137-1.256-2.732-3.979-8.7,6.608-7.4-1.188,16.229Z",
    transform: "translate(478.51 113.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M108.68,290.32l1.256,2.732-.611,8.237-.008.025-1.417-2.078Z",
    transform: "translate(476.227 105.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M135.657,262.435c-1.188.848-.848,8.483-1.179,13.276-.492,8-.967,14.922-.619,19.393a34.7,34.7,0,0,0,4.912-.619l.2-.042-.331-30.9a119.8,119.8,0,0,0,18.383-17.815,1.3,1.3,0,0,0-.212-1.892,157.343,157.343,0,0,1-21.149,18.6Z",
    transform: "translate(472.307 112.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M141.365,332.362c-.314-2.282-2.044-19.35-2.978-28.682l-4.488.5s6.541,53.725,6.965,71.3h2.078S141.8,335.518,141.365,332.362Z",
    transform: "translate(472.283 103.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M48.08,319.2l.161-.2a.848.848,0,0,0-.161.2Z",
    transform: "translate(485.299 100.809)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 124.586,
    height: 25.331,
    transform: "translate(631.006 422.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 124.586,
    height: 6.15,
    transform: "translate(631.006 422.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M175.384,322.75h11.368l-3.046,6.15H172.33Z",
    transform: "translate(466.455 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M205.586,322.75h11.368l-3.046,6.15H202.54Z",
    transform: "translate(461.873 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M235.786,322.75h11.368l-3.046,6.15H232.74Z",
    transform: "translate(457.293 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M265.984,322.75h11.359L274.3,328.9H262.93Z",
    transform: "translate(452.713 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M307.458,322.75v.17l-2.969,5.981H293.13l3.054-6.15Z",
    transform: "translate(448.133 100.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 8.78,
    height: 34.637,
    transform: "translate(646.514 448.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 1.994,
    height: 34.637,
    transform: "translate(653.299 448.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 8.78,
    height: 34.637,
    transform: "translate(731.982 448.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 2.596,
    height: 34.637,
    transform: "translate(738.166 448.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 8.78,
    height: 4.36,
    transform: "translate(646.514 448.296)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 8.78,
    height: 4.36,
    transform: "translate(731.982 448.296)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 8.78,
    height: 3.936,
    transform: "translate(646.514 419.029)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 1.994,
    height: 3.936,
    transform: "translate(653.299 419.029)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 8.78,
    height: 3.936,
    transform: "translate(731.982 419.029)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 2.596,
    height: 3.936,
    transform: "translate(738.166 419.029)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 8.78,
    height: 0.492,
    transform: "translate(646.514 422.473)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 8.78,
    height: 0.492,
    transform: "translate(731.982 422.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M185.361,322.75,172.8,348.081H163.16v-3.5l10.833-21.836Z",
    transform: "translate(467.846 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M203.884,322.75,191.32,348.081h11.368l12.564-25.331Z",
    transform: "translate(463.574 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M245.451,322.75l-12.564,25.331H221.52l12.564-25.331Z",
    transform: "translate(458.994 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M275.643,322.75l-12.555,25.331H251.72l12.564-25.331Z",
    transform: "translate(454.414 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294.484,322.75,281.92,348.081h11.359l12.479-25.161Z",
    transform: "translate(449.834 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.752,322.75l-3.046,6.15H172.33l3.054-6.15Z",
    transform: "translate(466.455 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M216.953,322.75l-3.046,6.15H202.54l3.046-6.15Z",
    transform: "translate(461.873 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M247.153,322.75l-3.046,6.15H232.74l3.046-6.15Z",
    transform: "translate(457.293 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M277.343,322.75,274.3,328.9H262.93l3.054-6.15Z",
    transform: "translate(452.713 100.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M307.458,322.92l-2.969,5.981H293.13l3.054-6.15Z",
    transform: "translate(448.133 100.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 118.97,
    height: 12.674,
    transform: "translate(634.475 433.951)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 7.83,
    cy: 7.83,
    r: 7.83,
    transform: "translate(641.672 407.072) rotate(-9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M189.259,310.965a3.546,3.546,0,1,0-1.036,2.513,3.555,3.555,0,0,0,1.036-2.513Z",
    transform: "translate(464.965 102.567)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 7.83,
    cy: 7.83,
    r: 7.83,
    transform: "translate(727.318 407.079) rotate(-9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M290.219,310.965a3.546,3.546,0,1,0-1.036,2.513,3.554,3.554,0,0,0,1.036-2.513Z",
    transform: "translate(449.652 102.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M358.566,382.332H318.89l6.032-14.71h0l2.443-5.938.67-1.62,1.1-2.655.221-.534,2.443-5.938.45-1.077,4.327-10.5a2.29,2.29,0,0,1,4.242,0l4.327,10.5.441,1.077,2.443,5.938.229.534,1.094,2.655.67,1.62,2.443,5.938h0Z",
    transform: "translate(444.227 97.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M321.494,382.84l-2.6,6.3h39.685l-2.6-6.3Z",
    transform: "translate(444.227 91.127)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 45.445,
    height: 6.422,
    transform: "translate(759.943 476.503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 9.815,
    height: 6.422,
    transform: "translate(795.572 476.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M360.056,378.557h-5.607l-4.513-10.935h0l-2.443-5.938-.67-1.629-1.094-2.647-.221-.543-2.443-5.938-.45-1.077L339,341l.687-1.7a2.29,2.29,0,0,1,4.242,0l4.326,10.5.441,1.077,2.443,5.938.229.543,1.094,2.647.67,1.629,2.443,5.938h0Z",
    transform: "translate(441.176 97.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M349.942,359.188H331.27l2.443-5.938H347.5Z",
    transform: "translate(442.348 95.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M353.585,371.858v.008H326.04v-.008l2.443-5.938h22.659Z",
    transform: "translate(443.141 93.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M351.841,359.188h-5.607l-2.443-5.938H349.4Z",
    transform: "translate(440.449 95.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M357.069,371.858v.008h-5.616v-.008l-2.443-5.938h5.616Z",
    transform: "translate(439.658 93.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M58.508,214.841a5.938,5.938,0,0,0,5.938-5.09,11.265,11.265,0,0,0,.11-1.612A11.877,11.877,0,0,0,52.68,196.263h-.8a12.581,12.581,0,0,0-25.111,1.069q0,.458,0,.916a12.581,12.581,0,0,0-18.663,10.07.925.925,0,0,1,0,.153,6,6,0,0,0,6.006,6.312Z",
    transform: "translate(491.363 121.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M391.312,226.3c9.332,0,9.883-14.091.526-14.549h-.763a15.448,15.448,0,0,0-4.793.755,16.067,16.067,0,0,0-31.778.5,14.905,14.905,0,0,0-10.1-.976c-8.186,2.1-6.473,14.286,1.985,14.286Z",
    transform: "translate(441.164 119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M258.756,144.447c9.332,0,9.883-14.082.534-14.54h-.772a15.644,15.644,0,0,0-4.785.747,16.059,16.059,0,0,0-31.77.509,14.854,14.854,0,0,0-10.1-.984c-8.186,2.112-6.464,14.286,1.985,14.286Z",
    transform: "translate(461.266 131.417)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 22.438,
    cy: 22.438,
    r: 22.438,
    transform: "translate(548.539 257.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M90.387,127.11a22.447,22.447,0,0,1-12.309,41.212H77.9a22.438,22.438,0,1,0,12.487-41.2Z",
    transform: "translate(480.777 129.913)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(521.898 368.572)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M437.058,308.226a1.448,1.448,0,0,0-.106-.246l-.333-.715a18.333,18.333,0,0,1-.966-2.856,25.3,25.3,0,0,1,.087-11.036,58.665,58.665,0,0,1,2.044-7.412c.87-2.634,1.875-5.427,2.7-8.442a32.627,32.627,0,0,0,1.329-9.7,37.909,37.909,0,0,0-2.257-10.268,50.066,50.066,0,0,1-2.614-10.114,15.415,15.415,0,0,1,1.86-9.345c1.479-2.725,3.339-5.054,4.731-7.47a25.948,25.948,0,0,0,2.846-7.181,26.687,26.687,0,0,0,.179-11.114,20.5,20.5,0,0,0-1.16-3.933,1.831,1.831,0,0,0,.068.261c.058.188.135.44.237.754a29.175,29.175,0,0,1,.72,2.943,27,27,0,0,1-.29,11.041,25.947,25.947,0,0,1-2.851,7.089c-1.392,2.387-3.262,4.706-4.769,7.466a15.725,15.725,0,0,0-1.933,9.529,50.191,50.191,0,0,0,2.619,10.191,38.358,38.358,0,0,1,2.252,10.172,32.6,32.6,0,0,1-1.3,9.6c-.807,3.006-1.8,5.8-2.658,8.437a58.583,58.583,0,0,0-2.015,7.456,24.873,24.873,0,0,0,.029,11.114,16.26,16.26,0,0,0,1.053,2.851l.367.7A1.135,1.135,0,0,0,437.058,308.226Z",
    transform: "translate(-412.103 -208.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M445.682,243.876s2.827-9.041-2.247-14.337a.309.309,0,0,0-.536.155C442.628,231.187,442.29,235.734,445.682,243.876Z",
    transform: "translate(-416.17 -219.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M445.32,235.88a8.287,8.287,0,0,0,.193,1.672c.184,1.145.4,2.5.643,3.987s.449,2.841.633,3.991a8.873,8.873,0,0,0,.3,1.648,6.76,6.76,0,0,0-.048-1.682c-.1-1.034-.275-2.455-.536-4.015s-.527-2.962-.744-3.977A7.589,7.589,0,0,0,445.32,235.88Z",
    transform: "translate(-417.504 -222.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M432.252,291.037s-1.73-9.316-8.7-11.6a.309.309,0,0,0-.4.386C423.6,281.247,425.425,285.426,432.252,291.037Z",
    transform: "translate(-406.041 -245.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M427.89,284.39a8.6,8.6,0,0,0,.966,1.382c.7.933,1.522,2.02,2.416,3.223l2.416,3.233a9.226,9.226,0,0,0,1.039,1.319,6.932,6.932,0,0,0-.831-1.45c-.565-.87-1.392-2.039-2.349-3.3s-1.851-2.373-2.522-3.165A7.113,7.113,0,0,0,427.89,284.39Z",
    transform: "translate(-408.496 -247.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M440.046,337.183s1.049-9.418-4.943-13.646a.314.314,0,0,0-.483.251C434.625,325.31,435.161,329.838,440.046,337.183Z",
    transform: "translate(-411.974 -267.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M437.93,329.49a8.27,8.27,0,0,0,.517,1.6c.4,1.1.87,2.377,1.392,3.793s.966,2.7,1.382,3.8a9.344,9.344,0,0,0,.609,1.561,6.763,6.763,0,0,0-.367-1.638c-.29-1-.739-2.358-1.29-3.866s-1.082-2.812-1.493-3.764A7.45,7.45,0,0,0,437.93,329.49Z",
    transform: "translate(-413.685 -270.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M428.685,386.029s.715-9.452-5.422-13.462a.314.314,0,0,0-.483.271C422.843,374.355,423.539,378.863,428.685,386.029Z",
    transform: "translate(-405.855 -293.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M426.29,378.44a7.8,7.8,0,0,0,.561,1.58l1.527,3.74c.57,1.4,1.082,2.667,1.517,3.745a9.368,9.368,0,0,0,.667,1.541,6.989,6.989,0,0,0-.43-1.628c-.324-.966-.821-2.329-1.425-3.793s-1.184-2.769-1.623-3.7a7.694,7.694,0,0,0-.793-1.483Z",
    transform: "translate(-407.67 -296.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M457.24,230.006s8.4-4.387,8.563-11.718a.314.314,0,0,0-.483-.271C464.063,218.877,460.608,221.849,457.24,230.006Z",
    transform: "translate(-423.664 -213.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M464.125,223.84a8.124,8.124,0,0,0-1.044,1.314c-.686.942-1.483,2.049-2.368,3.271s-1.691,2.329-2.378,3.266a9.185,9.185,0,0,0-.966,1.377,6.728,6.728,0,0,0,1.155-1.223c.662-.8,1.542-1.933,2.464-3.213s1.725-2.464,2.286-3.339A7.29,7.29,0,0,0,464.125,223.84Z",
    transform: "translate(-423.731 -216.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M438.57,270.742s8.649-3.866,9.263-11.177a.314.314,0,0,0-.483-.3C446.06,260.078,442.426,262.812,438.57,270.742Z",
    transform: "translate(-414.016 -234.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M446.016,264.93a7.869,7.869,0,0,0-1.126,1.247L442.33,269.3l-2.571,3.117a8.851,8.851,0,0,0-1.039,1.319,7.251,7.251,0,0,0,1.227-1.155c.71-.754,1.657-1.831,2.658-3.054s1.87-2.358,2.484-3.194a7.562,7.562,0,0,0,.928-1.4Z",
    transform: "translate(-414.093 -237.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M448.858,312.542s5.939-7.383,3.155-14.163a.314.314,0,0,0-.556-.053C450.66,299.616,448.679,303.728,448.858,312.542Z",
    transform: "translate(-419.326 -254.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M451.524,304.81a8.615,8.615,0,0,0-.435,1.624c-.246,1.136-.536,2.469-.855,3.948s-.618,2.808-.87,3.943a9.379,9.379,0,0,0-.324,1.643,6.852,6.852,0,0,0,.565-1.58c.29-1,.643-2.387.966-3.933s.59-2.952.754-3.977A7.609,7.609,0,0,0,451.524,304.81Z",
    transform: "translate(-419.427 -258.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M436.7,368.177s8.582-4.011,9.07-11.326a.314.314,0,0,0-.483-.295C444.006,357.363,440.421,360.185,436.7,368.177Z",
    transform: "translate(-413.049 -284.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M444.022,362.26a8.44,8.44,0,0,0-1.107,1.266l-2.508,3.17-2.493,3.17A9.006,9.006,0,0,0,436.9,371.2a7.107,7.107,0,0,0,1.2-1.174c.7-.763,1.628-1.86,2.609-3.1s1.831-2.387,2.416-3.233A7.8,7.8,0,0,0,444.022,362.26Z",
    transform: "translate(-413.153 -287.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M401.32,303.57v.812c.024.57.058,1.339.1,2.3.106,2.02.261,4.832.449,8.215h0a31.635,31.635,0,0,0,4.707,10.916c1.72,2.72,3.523,5.19,5.078,7.49a52.9,52.9,0,0,1,3.808,6.282,26.365,26.365,0,0,1,1.783,4.619c.15.565.261,1.005.329,1.31a2.357,2.357,0,0,0,.126.454,2.815,2.815,0,0,0-.058-.483c-.039-.309-.13-.759-.266-1.334a24.579,24.579,0,0,0-1.686-4.692,50.174,50.174,0,0,0-3.764-6.369c-1.546-2.315-3.339-4.789-5.05-7.495a32.223,32.223,0,0,1-4.706-10.785h0c-.237-3.382-.43-6.18-.575-8.215-.077-.966-.14-1.72-.184-2.29a4.5,4.5,0,0,0-.063-.6A.855.855,0,0,0,401.32,303.57Z",
    transform: "translate(-394.765 -257.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M410.426,332.526s-3.634-8.746.937-14.5a.314.314,0,0,1,.551.106C412.32,319.614,413.069,324.113,410.426,332.526Z",
    transform: "translate(-398.763 -264.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M412.351,324.5a7.52,7.52,0,0,0-.285,1.657c-.13,1.029-.275,2.455-.386,4.03s-.164,3.01-.164,4.044a6.768,6.768,0,0,0,.1,1.682,9.384,9.384,0,0,0,.145-1.672c.077-1.16.169-2.522.27-4.03s.2-2.87.28-4.03A8.1,8.1,0,0,0,412.351,324.5Z",
    transform: "translate(-400.027 -268.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M434.307,376.335s-2.9-9.017,2.107-14.356a.314.314,0,0,1,.541.15C437.24,363.617,437.617,368.164,434.307,376.335Z",
    transform: "translate(-411.381 -287.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M436.681,368.33a7.344,7.344,0,0,0-.42,1.628c-.213,1.015-.483,2.416-.71,3.982s-.411,2.986-.483,4.02a7.093,7.093,0,0,0-.034,1.681,8.761,8.761,0,0,0,.285-1.653c.169-1.15.372-2.5.594-3.991s.435-2.846.609-4A8.555,8.555,0,0,0,436.681,368.33Z",
    transform: "translate(-412.17 -291.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M394.788,312.086s-7.76-5.431-6.977-12.723a.314.314,0,0,1,.522-.208C389.458,300.189,392.5,303.586,394.788,312.086Z",
    transform: "translate(-387.755 -255.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M390.78,305.33a7.244,7.244,0,0,0,.643,1.551c.445.938,1.087,2.218,1.836,3.61s1.45,2.629,2.029,3.5a7.037,7.037,0,0,0,.991,1.363,9.115,9.115,0,0,0-.773-1.488l-1.933-3.547-1.933-3.552A8.424,8.424,0,0,0,390.78,305.33Z",
    transform: "translate(-389.318 -258.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M416,363.919s-9.365-1.45-11.872-8.35a.314.314,0,0,1,.377-.411C405.99,355.56,410.2,357.28,416,363.919Z",
    transform: "translate(-396.208 -284.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M409.24,359.8a7.572,7.572,0,0,0,1.266,1.107c.807.647,1.933,1.512,3.237,2.416s2.479,1.711,3.382,2.252a6.653,6.653,0,0,0,1.488.788,9.594,9.594,0,0,0-1.348-1l-3.31-2.315-3.291-2.344A8.362,8.362,0,0,0,409.24,359.8Z",
    transform: "translate(-398.858 -286.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M433.439,408.96l-2.682,17.613-10.727-.02-3.61-17.594Z",
    transform: "translate(-402.569 -312.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M419.67,418.391a.379.379,0,0,0,.087.068,2.917,2.917,0,0,0,.285.159,3.824,3.824,0,0,0,1.2.358,4.4,4.4,0,0,0,1.971-.184,4.146,4.146,0,0,0,2.121-1.541,3,3,0,0,0,.483-1.474,1.609,1.609,0,0,0-.73-1.512,1.749,1.749,0,0,0-1.8.145,2.619,2.619,0,0,0-1.024,1.619,6.839,6.839,0,0,0-.135,1.991,6.588,6.588,0,0,0,.435,2.034,4.5,4.5,0,0,0,1.242,1.773,3.445,3.445,0,0,0,2.063.86,3.74,3.74,0,0,0,2.15-.623,6.451,6.451,0,0,0,1.6-1.45,3.522,3.522,0,0,0,.812-1.933,2.242,2.242,0,0,0-.763-1.865,1.745,1.745,0,0,0-1.9-.116,2.044,2.044,0,0,0-1.1,1.45,2.749,2.749,0,0,0,1.358,2.788,3.793,3.793,0,0,0,2.59.377,5.866,5.866,0,0,0,1.841-.725,9.984,9.984,0,0,0,1.034-.7,1.938,1.938,0,0,0,.333-.285,3.244,3.244,0,0,0-.367.237c-.237.154-.585.391-1.053.647a5.918,5.918,0,0,1-1.817.657,3.619,3.619,0,0,1-2.455-.391,2.542,2.542,0,0,1-1.223-2.561,1.773,1.773,0,0,1,.966-1.252,1.45,1.45,0,0,1,1.614.1,1.976,1.976,0,0,1,.652,1.638,3.227,3.227,0,0,1-.759,1.773,6.123,6.123,0,0,1-1.527,1.377,3.518,3.518,0,0,1-1.981.58,3.2,3.2,0,0,1-1.885-.793,4.2,4.2,0,0,1-1.169-1.657,6.4,6.4,0,0,1-.42-1.933,6.765,6.765,0,0,1,.116-1.909,2.363,2.363,0,0,1,.908-1.45,1.488,1.488,0,0,1,1.532-.15,1.373,1.373,0,0,1,.624,1.29,2.819,2.819,0,0,1-.445,1.372,4.025,4.025,0,0,1-2,1.5,4.388,4.388,0,0,1-1.86.193A5.075,5.075,0,0,1,419.67,418.391Z",
    transform: "translate(-404.248 -314.689)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Illustration);
export default __webpack_public_path__ + "static/media/404-illustration.0dcf7e331b86b3e13e26dbf2e3cc0b5f.svg";
export { ForwardRef as ReactComponent };